import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/sealing/inspection/sample`,
    name: 'SEALING_INSPECTION_VALUE_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
